import dayjs from 'dayjs';

import { SIGNED_AT_FORMAT } from '@/constants/defaultDateFormat';

import { uploadSignature } from '@/utils/uploadSignature';

import { TSharedDebtScheduleDto, TSubmitDebtScheduleVars } from './debt-schedule.types';

import APIinstance from '../config';

import { DebtScheduleDto } from '@/generated-types';

const postDebtSchedules = async (
	applicationId: string,
	payload: DebtScheduleDto,
): Promise<void> => {
	await APIinstance.post<void>(`applications/${applicationId}/submit-debt-schedules`, payload);
};

const postSharedDebtSchedule = async (payload: TSharedDebtScheduleDto): Promise<void> => {
	await APIinstance.post<void>('shared-debt-schedules', payload);
};

/**
 * With the token of the Hub's Debt Schedule link, the schedule and the drawn signature go to the
 * link endpoint in one request: uploading the signature first needs a credential that page does
 * not have. Without a token this is the debt schedule that follows an application, and the draft
 * session authorizes the upload and the submit as before.
 */
export const submitDebtSchedule = async ({
	applicationId,
	linkToken,
	asOfDate,
	businessDebts,
	signerName,
	signature,
}: TSubmitDebtScheduleVars): Promise<void> => {
	const signedAt = dayjs().format(SIGNED_AT_FORMAT);
	if (linkToken) {
		await postSharedDebtSchedule({
			token: linkToken,
			asOfDate,
			businessDebts,
			signerName,
			signedAt,
			base64EncodedSignature: signature?.getTrimmedCanvas().toDataURL('image/png') ?? '',
		});
		return;
	}
	const uploadedSign = signature ? await uploadSignature(signature) : undefined;
	await postDebtSchedules(applicationId, {
		businessDebts,
		asOfDate,
		borrowerSignature: { signerName, signature: uploadedSign!, signedAt },
	});
};
